import { type ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { ROUTES } from "@/constants/routes";
import StatisticsPageHeader from "./page-headers/stats-page-header";
import UsersPageHeader from "./page-headers/users-page-header";
import UserCreatePageHeader from "./page-headers/user-create-page-header";
import ThemesPageHeader from "./page-headers/themes-page-header";
import ThemeCreatePageHeader from "./page-headers/theme-create-page-header";
import DilemmasPageHeader from "./page-headers/dilemmas-page-header";
import DynamicPageHeader from "./page-headers/dynamic-page-header";
import DilemmaCreatePageHeader from "./page-headers/dilemma-create-page-header";
import HistoryPageHeader from "./page-headers/history-page-header";
import SettingsPageHeader from "./page-headers/settings-page-header";
import AboutPageHeader from "./page-headers/about-page-header";
import AboutCreatePageHeader from "./page-headers/about-create-page-header";
import DocumentationPageHeader from "./page-headers/documentation-page-header";
import SubmissionPageHeader from "./page-headers/submissions-page-header";
import WarningsPageHeader from "./page-headers/warnings-page-header";
import AlertCreatePageHeader from "./page-headers/alert-create-page-header";

const staticRouteHeaders: Record<string, ReactNode> = {
  [ROUTES.DASHBOARD]: <StatisticsPageHeader />,
  [ROUTES.USERS]: <UsersPageHeader />,
  [ROUTES.USER_CREATE]: <UserCreatePageHeader />,
  [ROUTES.THEMES]: <ThemesPageHeader />,
  [ROUTES.THEME_CREATE]: <ThemeCreatePageHeader />,
  [ROUTES.DILEMMAS]: <DilemmasPageHeader />,
  [ROUTES.DILEMMA_CREATE]: <DilemmaCreatePageHeader />,
  [ROUTES.HISTORY]: <HistoryPageHeader />,
  [ROUTES.SETTINGS]: <SettingsPageHeader />,
  [ROUTES.ABOUT]: <AboutPageHeader />,
  [ROUTES.ABOUT_CREATE]: <AboutCreatePageHeader />,
  [ROUTES.DOCUMENTATION]: <DocumentationPageHeader />,
  [ROUTES.SUBMISSIONS]: <SubmissionPageHeader />,
  [ROUTES.WARNINGS]: <WarningsPageHeader />,
  [ROUTES.ALERT_CREATE]: <AlertCreatePageHeader />,
};

const dynamicRoutePrefixes = [
  ROUTES.USER_DETAILS(""),
  ROUTES.THEME_DETAILS(""),
  ROUTES.DILEMMA_DETAILS(""),
  ROUTES.ABOUT_DETAILS(""),
  ROUTES.ALERT_DETAILS(""),
];

const PageHeaderRenderer = () => {
  const { pathname } = useLocation();

  if (pathname in staticRouteHeaders) {
    return staticRouteHeaders[pathname];
  }

  if (dynamicRoutePrefixes.some((prefix) => pathname.startsWith(prefix))) {
    return <DynamicPageHeader />;
  }

  return null;
};

export default PageHeaderRenderer;
